"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.routes = void 0;
const types_1 = require("./types");
exports.routes = (0, types_1.buildRoutes)({
    aIActionRun: {
        path: "/ai-action-runs/:id",
    },
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYWlBY3Rpb25SdW5zLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vcm91dGluZy9haUFjdGlvblJ1bnMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUEsbUNBQXNDO0FBRXpCLFFBQUEsTUFBTSxHQUFHLElBQUEsbUJBQVcsRUFBQztJQUNoQyxXQUFXLEVBQUU7UUFDWCxJQUFJLEVBQUUscUJBQXFCO0tBQzVCO0NBQ0YsQ0FBQyxDQUFDIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgYnVpbGRSb3V0ZXMgfSBmcm9tIFwiLi90eXBlc1wiO1xuXG5leHBvcnQgY29uc3Qgcm91dGVzID0gYnVpbGRSb3V0ZXMoe1xuICBhSUFjdGlvblJ1bjoge1xuICAgIHBhdGg6IFwiL2FpLWFjdGlvbi1ydW5zLzppZFwiLFxuICB9LFxufSk7XG4iXX0=